import React from "react";
import { Content } from "../components/Content";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const WalletCurrency = () => {
  const { boxes } = useWalletAssets(4);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      <Content boxes={boxes} id={4} pageName="ارزی" />
    </div>
  );
};
